export const CadastralChangeEnum = {
  phone: 'phone',
  address: 'address',
  email: 'email',
};

export const ptBRCadastralChangeNameEnun = {
  celular: 'celular',
  endereco: 'endereco',
  email: 'email',
};

export const UnableToUpdateRegistrationInfoAction = {
  tryAgain: 'TRY_AGAIN',
  goToProfile: 'GO_TO_PROFILE',
  backToEdit: 'BACK_TO_EDIT',
  openWppHelpCentral: 'OPEN_WPP_HELP_CENTRAL',
  goToResellerPlaces: 'GO_TO_RESELLER_PLACES',
};

export const drawerTitle = {
  [CadastralChangeEnum.phone]: 'Alteração de celular',
  [CadastralChangeEnum.address]: 'Alteração de endereço',
  [CadastralChangeEnum.email]: 'Alteração de e-mail',
};

export const portugueseCadastralChangeName = {
  [CadastralChangeEnum.phone]: ptBRCadastralChangeNameEnun.celular,
  [CadastralChangeEnum.address]: ptBRCadastralChangeNameEnun.endereco,
  [CadastralChangeEnum.email]: ptBRCadastralChangeNameEnun.email,
};

export const ptBRCadastralChangeName = {
  [ptBRCadastralChangeNameEnun.celular]: 'número',
  [ptBRCadastralChangeNameEnun.endereco]: 'endereço',
  [ptBRCadastralChangeNameEnun.email]: 'e-mail',
};
